import { styles } from 'leds'

export const quantityButton = styles({
  borderColor: 'grey4',
  borderStyle: 'solid',
  size: 52,
  display: 'flex',
  justifyContent: 'center',
})
